<template>
  <div class="home" v-loading="loading">
    <!-- <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <div class="swiper-slide slide-one">
        <div class="page">
          <h3>{{ subTitle }}</h3>
          <p>{{ subTitleEn }}</p>
        </div>
        <p class="slogan">{{ mainTitle }}</p>
      </div> -->
    <div>
      <swiper v-bind:options="swiperOption">
        <swiper-slide v-for="(item, index) in banners" :key="index">
          <img :src="item" style="width: 100%;" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div id="latestNews" class="swiper-slide slide-two">
      <div class="page">
        <h3>最新资讯</h3>
        <p>Latest News</p>
      </div>
      <ul class="case-item">
        <li v-for="(item, index) in newsList" :key="index" v-lazy:background-image="imgurl + item.imgId">
          <router-link class="text-decoration" :to="{ name: 'newsdetails', params: { id: item.id } }">
            <div class="case-item-hover">
              <p class="hover-title">{{ item.title }}</p>
              <div class="bottom"></div>
              <div class="more">
                <span>MORE</span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>专用车辆与装备</h3>
          <p>Product Center</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(product, i) in productList" :key="i">
            <div :style="'order: ' + (i % 2 == 0 ? 1 : 3)">
              <router-link class="text-decoration" :to="{ name: 'productdetails', params: { id: product.id } }">
                <div class="item-img" v-lazy:background-image="imgurl + product.imgId"></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: ' + (i % 2 == 0 ? 3 : 1)">
              <h3>{{ product.name }} {{ product.subName }}</h3>
              <p>{{ product.intro }}</p>
              <span>{{ product.createTime }}</span>
            </div>
          </div>
        </div>
      </swiper-slide> -->
    <!-- </swiper> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      productList: [],
      mainTitle: '',
      subTitle: '',
      subTitleEn: '',
      banners: [
        require("../assets/img/home_top1.jpg"),
        require("../assets/img/home_top2.jpg"),
        require("../assets/img/home_top3.jpg"),
      ],
      swiperOption: {
        loop: true, // 开启循环
        autoplay: {
          delay: 5000,
        }, // 开启自动播放
        pagination: { // 配置分页
          el: '.swiper-pagination', // 指定dom
          clickable: true // 可以点击切换
        },
      }
    };
  },
  created() { },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // this.http.all([
    //   this.http.get("/case/list"),
    //   this.http.get(`/basic/news/list?showHomeFlag=true`),
    //   this.http.get(`/basic/product/list`),
    //   this.http.get(`/basic/data-dictionary?key=首页主标题`),
    //   this.http.get(`/basic/data-dictionary?key=首页副标题`),
    //   this.http.get(`/basic/data-dictionary?key=首页副标题英文`),
    // ])
    //   .then(
    //     this.http.spread((responseCases, responseNews, responseProduct, data1, data2, data3) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.productList = responseProduct.data;
    //       this.mainTitle = data1.data.content;
    //       this.subTitle = data2.data.content;
    //       this.subTitleEn = data3.data.content;
    //       this.loading = false;
    //     })
    //   );

    // this.http
    //   .get("/basic/banner/list?useCacheFlag=true")
    //   .then(response => {
    //     this.loading = false;
    //     // this.banners = response.data;
    //     response
    //   })
    //   .catch(e => {
    //     this.loading = false;
    //     this.$message({
    //       message: e,
    //       type: "error"
    //     });
    //   });
    this.http
      .get("/basic/news/list?showHomeFlag=true")
      .then(response => {
        this.loading = false;
        this.newsList = response.data;
      })
      .catch(e => {
        this.loading = false;
        this.$message({
          message: e,
          type: "error"
        });
      });
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: AliPuHuiLight;
  src: url('../assets/font/AlibabaPuHuiTi-3-45-Light.ttf')
}

@font-face {
  font-family: AliPuHuiBold;
  src: url('../assets/font/AlibabaPuHuiTi-3-85-Bold.ttf')
}

/* .el-header {
  position: absolute;
} */
.home {
  // height: 100%;
  background-color: #002057;
}

.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-content: center;

  .page {
    padding-top: 48px;
    text-align: center;
    // height: 100px;
    overflow: hidden;

    h3 {
      font-size: 48px;
      font-weight: bold;
      color: #fff;
      font-family: AliPuHuiBold;
    }

    p {
      font-size: 24px;
      font-weight: lighter;
      color: #fff;
      font-family: AliPuHuiLight;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    margin: 30px 0;
  }
}

//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 368px;
    height: 207px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    text-align: center;
    position: relative;
    bottom: 15px;

    span {
      color: #fff;
      font-size: 20px;
    }
  }
}

// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
// .slide-one {
//   background: url(../assets/img/home_top.jpg) no-repeat center;
//   background-size: cover;
//   height: 700px;
// } 

.slide-two {
  background: url(../assets/img/home_do2.png) no-repeat center;
  background-size: cover;
  position: relative;
  top: -5px;
}

// .slide-three {
//   background: url(../assets/img/home_anli.jpg) no-repeat center;
//   background-size: cover;
// }

//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 203px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }

    .el-divider {
      background-color: #fff;
      height: 3px;

      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }

    .item-content {
      width: 360px;
      height: 203px;
      margin: 0 auto;

      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }

      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }

      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}

.order {
  order: -1;
}

.order-img {
  order: 1;
}
</style>